const SUPABASE_AUTH_KEY_SUFFIX = '-auth-token';

export function getLegacySupabaseAuthKey(supabaseUrl: string): string | null {
  try {
    const projectRef = new URL(supabaseUrl).hostname.split('.')[0];
    return projectRef ? `sb-${projectRef}${SUPABASE_AUTH_KEY_SUFFIX}` : null;
  } catch {
    return null;
  }
}

export function prepareAdminAuthStorage(
  supabaseUrl: string,
  local: Storage,
  session: Storage,
): Storage {
  const legacyKey = getLegacySupabaseAuthKey(supabaseUrl);
  if (legacyKey) {
    local.removeItem(legacyKey);
  }

  return session;
}
